import BIT1 from '../assets/images/BIT1.png';
import BIT2 from '../assets/images/BIT2.png';
import BIT3 from '../assets/images/BIT3.png';
import BIT4 from '../assets/images/BIT4.png';
import BIT5 from '../assets/images/BIT5.png';
import BIT6 from '../assets/images/BIT6.png';
import BIT7 from '../assets/images/BIT7.png';
import BIT8 from '../assets/images/BIT8.png';

export default [
  {
    sn: '01',
    img: BIT1
  },
  {
    sn: '02',
    img: BIT2
  },
  {
    sn: '03',
    img: BIT3
  },
  {
    sn: '04',
    img: BIT4
  },
  {
    sn: '05',
    img: BIT5
  },
  {
    sn: '06',
    img: BIT6
  },
  {
    sn: '07',
    img: BIT7
  },
  {
    sn: '08',
    img: BIT8
  }
];
